import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "error"]
  static values = {
    maxTicketCount: Number,
    minTicketCount: { type: Number, default: 1 }
  }

  validate(event) {
    const totalCount = this.getTotalTicketCount()

    if (totalCount > this.maxTicketCountValue) {
      event.target.value = "0"
      this.showError(`Maximum of ${this.maxTicketCountValue} tickets allowed.`)
    } else if (totalCount > 0 && totalCount < this.minTicketCountValue) {
      // Below the private minimum: keep the selection so the guest can add to
      // it, and let the reservation-form controller keep submit disabled.
      this.showError(`Minimum of ${this.minTicketCountValue} tickets required.`)
    } else {
      this.hideError()
    }
  }

  getTotalTicketCount() {
    return this.selectTargets.reduce((sum, select) => sum + parseInt(select.value, 10), 0)
  }

  showError(message) {
    this.errorTarget.textContent = message
    this.errorTarget.style.display = "block"
  }

  hideError() {
    this.errorTarget.style.display = "none"
  }
}
